module.exports = __webpack_public_path__ + "img/mic-button-disabled-username.4dcb381e.svg";